
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconLink2OffSelector = "fhi-icon-link-2-off";

/**
 * ## FhiIconLink2Off
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-link-2-off
 * @element fhi-icon-link-2-off
 */
@customElement(FhiIconLink2OffSelector)
export class FhiIconLink2Off extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M1.47 1.47a.75.75 0 0 1 1.06 0l20 20 .052.056a.75.75 0 0 1-1.056 1.056l-.056-.052-9.78-9.78H8a.75.75 0 0 1 0-1.5h2.19L6.7 7.76a4.25 4.25 0 0 0 .3 8.49h2a.75.75 0 1 1 0 1.5H7A5.75 5.75 0 0 1 5.414 6.475L1.47 2.53a.75.75 0 0 1 0-1.06M17 6.25a5.75 5.75 0 0 1 5.727 6.267A5.75 5.75 0 0 1 21.6 15.45a.75.75 0 0 1-1.2-.9 4.25 4.25 0 0 0-3.4-6.8h-2a.75.75 0 0 1 0-1.5z"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
